import React, { createContext, useContext, useEffect, useState } from "react";
import { TR } from "@/data/translations";
import { SITE as DEFAULT_SITE } from "@/data/content";

const DEFAULTS = { tr: TR, site: DEFAULT_SITE };

const LanguageContext = createContext({
  lang: "pl",
  setLang: () => {},
  t: TR.pl,
  site: DEFAULT_SITE,
});

const detectLang = () => {
  try {
    const saved = localStorage.getItem("lang");
    if (saved === "pl" || saved === "en") return saved;
  } catch (e) {}
  const nav = (navigator.language || "pl").toLowerCase();
  return nav.startsWith("pl") ? "pl" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang);
  const [content, setContent] = useState(DEFAULTS);

  useEffect(() => {
    try {
      localStorage.setItem("lang", lang);
    } catch (e) {}
    document.documentElement.lang = lang;
  }, [lang]);

  // Load editable content from the CMS API; fall back to bundled defaults.
  useEffect(() => {
    let active = true;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${base}/api/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!active || !data || typeof data !== "object") return;
        const tr = data.tr && data.tr.pl && data.tr.en ? data.tr : DEFAULTS.tr;
        const site = data.site && Object.keys(data.site).length ? data.site : DEFAULTS.site;
        setContent({ tr, site });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const setLang = (l) => setLangState(l);

  return (
    <LanguageContext.Provider
      value={{ lang, setLang, t: content.tr[lang] || TR[lang], site: content.site }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useI18n = () => useContext(LanguageContext);
